module.exports = __webpack_public_path__ + "img/profil_lapper_da-silva.1a32a489.png";